// 成就页面
import Achievement from '@/views/achievement'

export default [
  {
    path: '/achievement',
    name: 'achievement',
    component: Achievement
  },
];
